(function () {
  function initMinimalHomepage(root) {
    if (!root || root.dataset.minimalHomepageInit === 'true') return;
    root.dataset.minimalHomepageInit = 'true';

    document.body.classList.add('minimal-home-active');
    document.body.classList.add('minimal-home-intro-active');

    const intro = root.querySelector('[data-minimal-intro]');
    const introVideo = root.querySelector('[data-minimal-intro-video]');
    let introReady = false;

    const cursor = root.querySelector('[data-minimal-cursor]');
    const ring = root.querySelector('[data-minimal-cursor-ring]');
    let mx = 0;
    let my = 0;
    let rx = 0;
    let ry = 0;

    document.addEventListener('mousemove', function (event) {
      mx = event.clientX;
      my = event.clientY;

      if (cursor) {
        cursor.style.transform = 'translate(' + (mx - 4) + 'px,' + (my - 4) + 'px)';
      }
    });

    (function animateCursor() {
      rx += (mx - rx - 16) * 0.12;
      ry += (my - ry - 16) * 0.12;

      if (ring) {
        ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px)';
      }

      requestAnimationFrame(animateCursor);
    })();

    root.querySelectorAll('a, button, input').forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (!ring) return;
        ring.style.width = '48px';
        ring.style.height = '48px';
        ring.style.borderColor = 'rgba(0,229,204,.8)';
      });

      el.addEventListener('mouseleave', function () {
        if (!ring) return;
        ring.style.width = '32px';
        ring.style.height = '32px';
        ring.style.borderColor = 'rgba(0,229,204,.5)';
      });
    });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    root.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });

    function closeIntro() {
      if (!intro || intro.dataset.closed === 'true' || introReady !== true) return;
      intro.dataset.closed = 'true';
      intro.classList.add('is-exiting');
      intro.removeAttribute('tabindex');

      window.setTimeout(function () {
        intro.classList.add('is-hidden');
        document.body.classList.remove('minimal-home-intro-active');
      }, 1150);
    }

    function markIntroReady() {
      if (!intro || intro.dataset.ready === 'true') return;
      intro.dataset.ready = 'true';
      introReady = true;
      intro.classList.add('is-ready');
      intro.setAttribute('tabindex', '0');
      intro.focus({ preventScroll: true });
    }

    if (introVideo) {
      intro.addEventListener('click', closeIntro);

      intro.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          closeIntro();
        }
      });

      // LOOP CONTINUO: el vídeo ya no termina, así que 'ended' no se dispara nunca.
      // Marcamos el intro como listo cuando completa su primera vuelta (currentTime
      // se reinicia), de modo que el vídeo nunca se congela en negro.
      let introLastTime = 0;
      introVideo.addEventListener('timeupdate', function () {
        if (introVideo.currentTime + 0.05 < introLastTime) {
          markIntroReady();
        }
        introLastTime = introVideo.currentTime;
      });

      // Red de seguridad: si el loop fallara o el vídeo no cargara, no dejamos
      // al usuario atrapado en el intro.
      window.setTimeout(markIntroReady, 7000);

      introVideo.addEventListener('ended', function () {
        markIntroReady();
      });

      introVideo.addEventListener('error', function () {
        introReady = true;
        closeIntro();
      });

      const playPromise = introVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          introReady = true;
          closeIntro();
        });
      }
    } else {
      introReady = true;
      closeIntro();
    }
  }

  function initAllMinimalHomepages() {
    document.querySelectorAll('.minimal-homepage').forEach(initMinimalHomepage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllMinimalHomepages);
  } else {
    initAllMinimalHomepages();
  }
})();
